import { lang } from '@sc/data-access-models';

// Mapping between each supported language and the css class corresponding to their flags
export const languageFlagMapping: Record<lang, string> = {
  fr_FR: 'flag-icon-fr',
  en_GB: 'flag-icon-gb',
  en_US: 'flag-icon-us',
  es_ES: 'flag-icon-es',
  pt_BR: 'flag-icon-br',
  et_EE: 'flag-icon-ee',
  fi_FI: 'flag-icon-fi',
  el_GR: 'flag-icon-gr',
  it_IT: 'flag-icon-it',
  lt_LT: 'flag-icon-lt',
  nb_NO: 'flag-icon-no',
  pt_PT: 'flag-icon-pt',
  ru_RU: 'flag-icon-ru',
  de_DE: 'flag-icon-de',
  hu_HU: 'flag-icon-hu',
  nl_NL: 'flag-icon-nl',
};
